import React from 'react';
import { Box, TextField, Button, Grid, Autocomplete } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface FiltersProps {
  company: string;
  setCompany: (val: string) => void;
  dateRange: { from: string; to: string };
  setDateRange: (range: { from: string; to: string }) => void;
  companies: string[];
  onSearch: () => void;
  onReset: () => void;
  loading?: boolean;
}

const Filters: React.FC<FiltersProps> = ({
  company,
  setCompany,
  dateRange,
  setDateRange,
  companies,
  onSearch,
  onReset,
  loading = false
}) => {
  const isSearchDisabled = !dateRange.from || !dateRange.to || loading;

  return (
    <Box>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            freeSolo
            options={companies}
            value={company}
            onInputChange={(_e, value) => setCompany(value ?? '')}
            onChange={(_e, value) => setCompany(value ?? '')}
            size="small"
            disabled={loading}
            renderInput={params => (
              <TextField
                {...params}
                label="Company Name"
                placeholder="Type or select company"
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            type="date"
            label="From Date"
            InputLabelProps={{ shrink: true }}
            size="small"
            value={dateRange.from}
            onChange={e => setDateRange({ ...dateRange, from: e.target.value })}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            type="date"
            label="To Date"
            InputLabelProps={{ shrink: true }}
            size="small"
            value={dateRange.to}
            onChange={e => setDateRange({ ...dateRange, to: e.target.value })}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<SearchIcon />}
            sx={{ height: '40px' }}
            onClick={onSearch}
            disabled={isSearchDisabled}
          >
            Search
          </Button>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{ height: '40px' }}
            onClick={onReset}
            disabled={loading}
          >
            Reset Filters
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filters;